import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

const { colors, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	richContentFilterOptionsContainer: {
		borderBottom: THEME.common.border,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		padding: '15px 0',
	},
	tabIcon: {
		display: 'inline-block',

		'@container companyActivity (min-width: 400px)': {
			display: 'none',
		},

		'@container companyActivity (min-width: 600px)': {
			display: 'inline-block',
		},
	},
	tabList: {
		alignItems: 'center',
		background: colors.background.light,
		borderBottom: THEME.common.border,
		boxSizing: 'border-box',
		display: 'flex',
		gap: spacing.xl,
		height: 60,
		justifyContent: 'flex-start',
		position: 'sticky',
		top: 0,
		width: '100%',
		zIndex: 3,
	},
	tabRoot: {
		paddingLeft: spacing.md,
	},
	tabTitle: {
		display: 'none',
		textAlign: 'center',

		'@container companyActivity (min-width: 400px)': {
			display: 'inline-block',
		},
	},
	tabTrigger: {
		alignItems: 'center',
		color: colors.text.light,
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.semibold,
		gap: spacing.sm,
		height: '100%',
		justifyContent: 'center',
		textDecoration: 'none',
		':is([data-state="active"])': {
			borderBottom: `3px solid ${colors.primary.main}`,
			color: colors.primary.main,
		},
	},
	timelineFilterOptionsContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		paddingTop: spacing.md,
	},
});
